module.exports = __webpack_public_path__ + "img/img60_1.3ed50a68.png";